import { ReportType } from '@common/types';
import { NonOptionalArrayProps } from '@common/types/utilities.ts';
import { paths } from '@types';

export type ReportFilters = NonOptionalArrayProps<
  NonNullable<paths['/reporting/reports']['get']['parameters']['query']>
> & { tabIndex: string };

export type FormatedReportType = 'patients' | 'tasks' | 'record' | 'users';

export const reportTypeOptions = [
  {
    value: ReportType.PATIENTS,
    label: 'Patients',
  },
  {
    value: ReportType.TASKS,
    label: 'Tasks',
  },
  {
    value: ReportType.USERS,
    label: 'Users',
  },
  {
    value: ReportType.RECORDS,
    label: 'Records',
  },
];
